<mat-form-field>
  <mat-label class="h5">{{ label }}</mat-label>
  <mat-select [(value)]="selectedId"
    (change)="onSettingsChanged($event.target.value)">
    <mat-option [value]="device.deviceId" *ngFor="let device of devices">{{ device.label }}</mat-option>
  </mat-select>
</mat-form-field>
